import React, {useEffect, useRef, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import FileUpload from "../../../FileUploads/FileUpload";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import Moment from 'moment';
import SuccessModal from "../../../CustomModal/Success";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import DistanceCalculatorV2 from "../../../DistanceCalculatorV2";
import distanceBetweenTwoPoints from "../../../DistanceBetweenTwoPoints";
import {generateRandomString} from "../../../Common";
import {versionCheck} from "../../../Common";
import useSiteDistance from "../../../../hooks/currentlocation/useSiteDistance";
import {markAttendance} from "../../../../service/DCC/action";

const CompleteValetActivity = ({
                                   documentUploadUrlPublic,
                                   documentUrlDataPublic,
                                   history,
                                   match,
                                   activityTypesDetails = [],
                                   activityTypes,
                                   saveActivity,
                                   saveActivityRes = [],
                                   activityByIdDetails = [],
                                   viewActivity,
                                   getSenior,
                                   senior = [],
                                   getPendingActivity,
                                   pendingActivity = [],
                                   accountById,
                                   accountDetailsByIdData,
                                   errorLogs,
                                   markAttendance,
                                   attendance,
                                   isUserCheckInForModule,
                                   userCheckInForModule
                               }) => {

    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        meta_data: {},
        lat: '',
        long: '',
        activity_type_id: '',
        activity_date: '',
        description: '',
        meeting_outcome: [{}]
    }])
    const [isActivityCreated, setIsActivityCreated] = useState(false);
    const [distance, setDistance] = useState()
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [isEdit, setIsEdit] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [message, setMessage] = useState('')
    const [outcome, setOutcome] = useState('')
    const [wordsUsed, setWordsUsed] = useState(0)
    const currentUserLocation = useRef(null);
    const [openCheckIn, setOpenCheckIn] = useState(false);
    const [checkInText, setCheckInText] = useState("");
    const [hideCheckIn, setHideCheckIn] = useState(false);
    const [deviceId, setDeviceId] = useState('')
    const [isMockLocation, setIsMockLocation] = useState(false)
    const [isLocationFetching, setIsLocationFetching] = useState(false);
    const [locationStatus, setLocationStatus] = useState(null);
    const [userId, setUserId] = useState('')

    let siteDistance = useSiteDistance(
        accountDetailsByIdData?.data?.latitude,
        accountDetailsByIdData?.data?.longitude
    )

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            setUserId(window.localStorage.user_id);
            await viewActivity(match?.params?.id);
            await activityTypes('is_valet');
            await getSenior();
            await getPendingActivity(match?.params?.account_id !== undefined ? match?.params?.account_id : "");
            await accountById(match?.params?.account_id);
            await isUserCheckInForModule('Valet', match?.params?.account_id, 'account_id', false)
            setIsLoading(false);
        })()
        if (match?.params?.is_edit !== undefined && parseInt(match?.params?.is_edit) === 1) {
            setIsEdit(true);
        }
    }, [])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    useEffect(() => {
        if (pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0) {
            setIsActivityCreated(true)
        }
    }, [pendingActivity])


    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        list['activity_type_id'] = activityByIdDetails?.data?.activity_type_id
        if (list['activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }

        list['activity_date'] = currentDate
        if (list['activity_date'] === '') {
            toast.error("Please choose activity date")
            return false
        }

        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        list['id'] = activityByIdDetails?.data?.id

        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (!isActivityCreated && list['activity_type_id'] !== '') {
            toast.error("No pending activity! Create new one.")
            return false
        }
        // console.log("listlistlistlist " + JSON.stringify(list))
        // return false
        if (list?.meta_data?.Remark !== undefined && list?.meta_data?.Remark.length < 60) {
            toast.warning("MOM must be minimum 60 characters");
            return false;
        }
        setIsLoading(true)
        await saveActivity(list)
        setIsLoading(false)
    }

    const handleInput = (key, val, metaKey, e, i = 0) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else if (metaKey === 'meeting_outcome') {
            if (inputList[0][metaKey][i]['Outcome'] !== undefined && inputList[0][metaKey][i]['Outcome'] !== val && key === "Outcome") {
                inputList[0][metaKey][i] = {}
            }
            // inputList[0][metaKey][i] = {}
            inputList[0][metaKey][i][key] = val
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }


    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        // show check out after complete activity
        if (saveActivityRes?.data !== undefined && saveActivityRes?.status === 200) {
            setMessage(saveActivityRes?.message)
            setIsSuccessModalOpen(true)
            setCheckInText('Check out');
            setOpenCheckIn(true);
        } else if (saveActivityRes?.data !== undefined && saveActivityRes?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setMessage(saveActivityRes?.message)
        }
    }, [saveActivityRes])

    const handleWordUsed = (value) => {
        setWordsUsed(value.split(" ").length - 1)
    }

    useEffect(async () => {
        const webView = window.localStorage?.webview;
        if (versionCheck('3.0.0')) {
            if (webView !== undefined && webView == 'true') {
                setIsLocationFetching(true);
                getUserLocation();
            } else {
                setIsLoading(true);
                setLocationStatus('granted');
                currentUserLocation.current = await getLocation();
                setIsLocationFetching(false);
                setIsLoading(false)
            }
        }
    }, []);

    function locationCallback(data) {
        if (data.detail) {
            if (data?.detail?.gps_status === "granted") {
                if (data.detail.status === "granted") {
                    setLocationStatus("granted");
                    currentUserLocation.current = {
                        lat: data?.detail?.latitude,
                        long: data?.detail?.longitude,
                        is_mock: data.detail.mocked,
                        device_id: data.detail.device_id
                    }
                } else {
                    setLocationStatus("permission_denied");
                }
            } else {
                setLocationStatus("gps_denied");
            }
        }
        setIsLocationFetching(false);
    }

    const getUserLocation = () => {
        let eventName = `locationEvent${generateRandomString()}`;
        window.addEventListener(eventName, locationCallback)
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event_name: "get_current_location",
            data: {
                accuracy: 4,
                callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
            }
        }));
        return () => {
            window.removeEventListener(eventName, locationCallback)
        }
    }

    function getLocation() {

        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.permissions.query({name: 'geolocation'}).then(permissionStatus => {
                    if (permissionStatus.state === 'denied') {
                        alert('Please allow location access.');
                        setIsLoading(false);
                        reject('Location access denied.');
                    } else {
                        setLocationStatus('granted')
                        navigator.geolocation.getCurrentPosition(
                            (success) => {
                                if (success?.coords && success.coords.latitude) {
                                    const location = {
                                        lat: success.coords.latitude,
                                        long: success.coords.longitude,
                                        is_mock: false,
                                        device_id: ''
                                    };
                                    setIsLoading(false);
                                    resolve(location);
                                }
                            },
                            (error) => {
                                setIsLoading(false);
                                reject(error);
                            }
                        );
                    }
                }).catch(err => {
                    setIsLoading(false);
                    reject(err);
                });
            } else {
                setIsLoading(false);
                reject('Geolocation not supported.');
            }
        });
        // setIsLoading(false);
    }

    useEffect(() => {
        setHideCheckIn(false)
        if (accountDetailsByIdData && accountDetailsByIdData?.data !== undefined && accountDetailsByIdData?.data?.longitude !== undefined) {
            let distance = 0;
            if (versionCheck('3.0.0')) {
                if (currentUserLocation?.current?.lat && currentUserLocation?.current?.long) {
                    distance = distanceBetweenTwoPoints(accountDetailsByIdData?.data?.latitude, currentUserLocation?.current?.lat, accountDetailsByIdData?.data?.longitude, currentUserLocation?.current?.long);
                }

                if (window.localStorage?.device_id) {
                    setDeviceId(window.localStorage?.device_id)
                } else if(currentUserLocation?.current?.device_id){
                    setDeviceId(currentUserLocation?.current?.device_id)
                }

                if (currentUserLocation.current?.is_mock) {
                    setIsMockLocation(true)
                }
                if (distance > 0.50 && checkInText === "Check In") {
                    if (parseInt(userId) !== 397) {
                        setHideCheckIn(true);
                        setOpenCheckIn(false);
                    }
                }
                setDistance(parseFloat(distance).toFixed(2))
            }

            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
        }
    }, [accountDetailsByIdData, currentUserLocation?.current?.lat])

    useEffect(() => {
        setHideCheckIn(false)
        if (accountDetailsByIdData && accountDetailsByIdData?.data !== undefined && accountDetailsByIdData?.data?.longitude !== undefined) {
            let distance = 0;
            if (!versionCheck('3.0.0')) {
                if (siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN') {
                    distance = siteDistance?.distance_in_km;
                }
                if (window.localStorage?.device_id) {
                    setDeviceId(window.localStorage?.device_id)
                } else if(siteDistance?.current?.device_id){
                    setDeviceId(siteDistance?.current?.device_id)
                }

                if (distance > 0.5 && checkInText === "Check In") {
                    setHideCheckIn(true);
                    setOpenCheckIn(false);
                }

                setDistance(parseFloat(distance).toFixed(2) + " km away from site")
            }

            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
        }
    }, [accountDetailsByIdData, siteDistance])

    const handleErrorLogsSave = async (msg, type) => {
        setIsLoading(true)
        await errorLogs({
            module_type: "Valet",
            message: msg,
            type: type,
            device_id: window.localStorage.device_id ?? null
        })
        setIsLoading(false)
    }

    useEffect(() => {
        if (isMockLocation) {
            setOpenCheckIn(false)
            setHideCheckIn(true)
            // toast.error('Location morphing is cheating. Check in not allowed');
            handleErrorLogsSave(`Location morphing is cheating. ${checkInText} not allowed`, checkInText);
            setCountToOpenModal(countToOpenModal + 1);
        }
    }, [isMockLocation])

    const refreshUserLocation = async (e) => {
        e.preventDefault();
        const webView = window.localStorage?.webview;
        if (webView !== undefined && webView == 'true') {
            setIsLocationFetching(true);
            getUserLocation();
        } else {
            setIsLoading(true);
            setIsLocationFetching(true);
            currentUserLocation.current = await getLocation();
            setIsLocationFetching(false);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        // after check in hide popup
        if (attendance?.data !== undefined) {
            if (attendance?.status === 200) {
                setOpenCheckIn(false);
                toast.success("Attendance is marked successfully");
                window.location.reload();
            } else if (attendance?.status === 400) {
                setOpenCheckIn(false);
                toast.error(attendance?.message);
            }
        }
    }, [attendance])

    useEffect(() => {
        //  if activity is completed then check is either check out or not, if not then open check out popup
        setOpenCheckIn(false)
        if(activityByIdDetails?.data) {
            if(userCheckInForModule === null){
                setOpenCheckIn(true);
                setCheckInText("Check In");
            }

            if (userCheckInForModule && activityByIdDetails &&  activityByIdDetails?.data &&
                userCheckInForModule?.check_out_lat === null &&
                Object.keys(activityByIdDetails?.data).length === 0
            ) {
                console.log("userCheckInForModule", userCheckInForModule)
                setCheckInText("Check out");
                setOpenCheckIn(true);
            }

            if (activityByIdDetails?.data && Object.keys(activityByIdDetails?.data).length > 0) {
                setIsActivityCreated(true);
            }

            if(userCheckInForModule && userCheckInForModule?.check_out_lat === null && parseInt(activityByIdDetails?.data?.status) === 2){
                setCheckInText("Check out");
                setOpenCheckIn(true);
            }

            if(userCheckInForModule && userCheckInForModule?.check_out_lat !== null && parseInt(activityByIdDetails?.data?.status) === 2){
                window.location.href=`valet-activity-list/${activityByIdDetails?.data?.opportunity_id}/${activityByIdDetails?.data?.account_id}`;
            }
        }

    }, [userCheckInForModule, activityByIdDetails]);


    return (
        <>
            {/*<SuccessModal*/}
            {/*    isOpen={isSuccessModalOpen}*/}
            {/*    msg={message}*/}
            {/*    url={`valet-activity-list/${activityByIdDetails?.data?.opportunity_id}/${activityByIdDetails?.data?.account_id}`}*/}
            {/*/>*/}

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={message}
                countToOpenModal={countToOpenModal}
            />
            {isMockLocation &&
                <FailedModal
                    isOpen={isMockLocation}
                    msg={`Location morphing is cheating. ${checkInText} not allowed`}
                    countToOpenModal={countToOpenModal}
                    url={`valet-activity-list/${activityByIdDetails?.data?.opportunity_id}/${activityByIdDetails?.data?.account_id}`}
                />
            }
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            <>
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {!versionCheck('3.0.0') ?
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100">
                                                        {distance &&
                                                            <span style={{color: "green"}}> {distance}</span>
                                                        }
                                                    </h1>
                                                </div> :
                                                <div
                                                    className="d-flex align-items-center justify-content-between com-sub-heading">
                                                    {isLocationFetching ? "Location fetching..." : ""}
                                                    {locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                                        <span
                                                            style={{color: "green"}}
                                                            className="ml-5">{distance + " km away from site"}
                                                            </span> :
                                                        <h1 className="h3 mb-0 text-black-100">
                                                            {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                            <span
                                                                style={{color: "green"}}
                                                                className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the application</span>
                                                        </h1>
                                                    }
                                                    <button className="btn btn-primary mr-4" onClick={(e) => {
                                                        refreshUserLocation(e)
                                                    }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                                                </div>
                                            }
                                            {/*<div className="mb-0 bg-white">*/}
                                            {openCheckIn ? (
                                                <div className="popup-box">
                                                    <div className="box">
                                                        {!versionCheck('3.0.0') ?
                                                            <DistanceCalculator
                                                                isMapShow={true}
                                                                calculateDistance={markAttendance}
                                                                moduleType={"Valet"}
                                                                checkInText={checkInText}
                                                                checkoutId={userCheckInForModule ? userCheckInForModule?.id : 0}
                                                                activityId={
                                                                    activityByIdDetails?.data?.id !== undefined
                                                                        ? activityByIdDetails?.data?.id
                                                                        : ""
                                                                }
                                                                documentUploadUrlPublic={documentUploadUrlPublic}
                                                                documentUrlDataPublic={documentUrlDataPublic}
                                                                showSelfie={true}
                                                                hideCheckButton={hideCheckIn}
                                                                distance={distance}
                                                                lat={accountDetailsByIdData?.data?.latitude}
                                                                long={accountDetailsByIdData?.data?.longitude}
                                                                deviceId={deviceId}
                                                                accountId={match?.params?.account_id}
                                                                module_name={'is_valet'}
                                                                // deviceIdCheck={true}
                                                            />
                                                            :
                                                            <DistanceCalculatorV2
                                                                isMapShow={true}
                                                                calculateDistance={markAttendance}
                                                                moduleType={"Valet"}
                                                                checkInText={checkInText}
                                                                checkoutId={userCheckInForModule ? userCheckInForModule?.id : 0}
                                                                activityId={
                                                                    activityByIdDetails?.data?.id !== undefined
                                                                        ? activityByIdDetails?.data?.id
                                                                        : ""
                                                                }
                                                                documentUploadUrlPublic={documentUploadUrlPublic}
                                                                documentUrlDataPublic={documentUrlDataPublic}
                                                                showSelfie={true}
                                                                hideCheckButton={hideCheckIn}
                                                                distance={distance}
                                                                lat={accountDetailsByIdData?.data?.latitude}
                                                                long={accountDetailsByIdData?.data?.longitude}
                                                                deviceId={deviceId}
                                                                accountId={match?.params?.account_id}
                                                                module_name={'is_valet'}
                                                                // deviceIdCheck={true}
                                                            />
                                                        }

                                                    </div>
                                                </div>
                                            ) : (<>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('activity_type_id', e.target.value, e)
                                                                    }}
                                                                    disabled={true}>
                                                                    <option value="">Select Activity
                                                                    </option>
                                                                    {activityTypesDetails?.data !== undefined && activityTypesDetails?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                {(activityByIdDetails?.data?.activity_type_id !== undefined &&
                                                                                    activityByIdDetails?.data?.activity_type_id === parseInt(val?.id)) ?
                                                                                    <option
                                                                                        value={val?.id}
                                                                                        selected={true}>{val.name}
                                                                                    </option> :
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity Type
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="datetime-local"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('activity_date', e.target.value, e)
                                                                           setCurrentDate(e.target.value)
                                                                       }}
                                                                       id="validationCustom01"
                                                                       disabled={true}
                                                                       value={activityByIdDetails?.data?.activity_date !== undefined ? activityByIdDetails?.data?.activity_date : ""}
                                                                       max={new Date().toISOString().split("T")[0] + "T00:00"}
                                                                    // value={currentDate}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Activity Date
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 mt-1 float-field"
                                                                style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('Outcome', e.target.value, 'meeting_outcome', e)
                                                                        // handleOutcome(i, e.target.value)
                                                                    }}
                                                                    required={true}>
                                                                    <option
                                                                        value="">Select
                                                                        Outcome
                                                                    </option>
                                                                    <option
                                                                        value={"Initial Pitch + Inspection done"}>Initial
                                                                        Pitch + Inspection done
                                                                    </option>
                                                                    <option
                                                                        value={"Proposal sent"}>Proposal sent
                                                                    </option>
                                                                    <option
                                                                        value={"Proposal/Commercials Discussed"}>Proposal/Commercials
                                                                        Discussed
                                                                    </option>
                                                                    <option
                                                                        value={"Follow Up Done - Next Date Given"}>Follow
                                                                        Up Done - Next Date Given
                                                                    </option>
                                                                    <option
                                                                        value={"Pilot Closed - With Date"}>Pilot Closed
                                                                        - With Date
                                                                    </option>
                                                                    <option
                                                                        value={"Commercials Approved"}>Commercials
                                                                        Approved
                                                                    </option>
                                                                    <option
                                                                        value={"Agreement Discussed"}>Agreement
                                                                        Discussed
                                                                    </option>
                                                                    <option
                                                                        value={"Agreement Closed + Ops Alignment"}>Agreement
                                                                        Closed + Ops Alignment
                                                                    </option>
                                                                    <option
                                                                        value={"Gone Cold"}>Gone Cold
                                                                    </option>
                                                                </select>
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Outcome
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'Stage', e)
                                                                        setOutcome(e.target.value)
                                                                    }}
                                                                >
                                                                    <option value="">Select Stage
                                                                    </option>
                                                                    <option
                                                                        value="Hot">Hot
                                                                    </option>
                                                                    <option
                                                                        value="Cold">Cold
                                                                    </option>
                                                                    <option
                                                                        value="Warm">Warm
                                                                    </option>
                                                                    <option
                                                                        value="Closed - Won">Closed - Won
                                                                    </option>
                                                                    <option
                                                                        value="Closed - Lost">Closed - Lost
                                                                    </option>
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Stage
                                                                    Stage
                                                                </label>
                                                            </div>
                                                            {outcome === "Closed - Won" &&
                                                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                                                    <input type="datetime-local"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput('meta_data', e.target.value, 'Expected Go Live', e)
                                                                           }}
                                                                           id="validationCustom01"
                                                                           min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                           value={currentDate}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Expected Go Live
                                                                    </label>
                                                                </div>
                                                            }
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                                <div className="userWords"
                                                                     style={{color: "cornflowerblue", left: "6px"}}>
                                                                    Total used Word {wordsUsed}
                                                                </div>
                                                                <textarea
                                                                    className="form-control form-control-user"
                                                                    placeholder="Internal MOM"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'Remark', e)
                                                                        handleWordUsed(e.target.value)
                                                                    }}
                                                                    id="validationCustom01"
                                                                    rows="4" cols="50"
                                                                    required={true}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Description*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field mb-3">
                                                                <FileUpload
                                                                    id={"addAttachment"}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(e, val) => {
                                                                        handleInput('meta_data', e, 'Document', e)
                                                                    }}
                                                                    prefilledFilename={""}
                                                                    multiple={true}
                                                                >
                                                                    File Attachment
                                                                </FileUpload>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </>)
                                            }

                                        </div>
                                    </div>
                                </form>
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default CompleteValetActivity